import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { BrandProvider } from './branding/BrandContext';
import { I18nProvider } from './lib/i18n';
import { initSentry } from './lib/sentry';
import './styles/globals.css';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <BrandProvider>
          <App />
        </BrandProvider>
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
